
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {UserCollection} from '@/model/collection/UserCollection'
import {FilterUserSchema} from '@/schema/resource/User/FilterUserSchema'

@Component
export default class FilterUser extends Vue {
  @Prop({type: Object, required: true}) collection!: UserCollection

  schema = new FilterUserSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = []

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
